import '.cd{flex-shrink:0;}.ssr-plugin'
import '.cn{width:20rem;}.ssr-plugin'
import '.bc{border:var(--blue-border);}.ssr-plugin'
import '.ai{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.ap{border-radius:1.25rem;}.ssr-plugin'
import '.ce{padding:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a1{gap:2rem;}.ssr-plugin'
import '.co{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="cd cn bc ai ap ce"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="a a1 co"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
